import bdjs from "@bd-core/bdjs";
import CONFIG from "@bd-core/config";
import GameLogic from "@bd-core/game-logic";
import $ from "jquery";

export default class TimeoutPopup {
    constructor() {
        this.elms = {
            popup: ".js-timeout-popup",
            closeBtn: ".js-timeout-close",
        };
    }

    init() {
        const elms = this.elms;
        const $popup = $(elms.popup);

        $popup.find(elms.closeBtn).on("click", this.hide.bind(this));
    }

    show() {
        const $popup = $(this.elms.popup);
        bdjs.hideLoading();
        $popup.addClass("is-open");
    }

    hide() {
        const $popup = $(this.elms.popup);
        $popup.removeClass("is-open");

        bdjs.showLoading();
        const currentLang = CONFIG.wpml_config.current_language;
        setTimeout(() => {
            //go to result page on video ended
            document.location.href = CONFIG.siteURL + "/result/?lang=" + currentLang;
        }, GameLogic.transisitonDuration);
    }
}